module.exports = __webpack_public_path__ + "static/img/8.52e2299.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/8.png
// module id = swdK
// module chunks = 0